<template>
  <div style="background-color: #e7ebf3;">
    <slot></slot>
    <div v-if="loading" class="loading">Loading more…</div>
  </div>
</template>

<script>
import { listenerScrollToBottom, listenerFixedJobBoard } from '@/tools/tool.js'

// 该组件需要一个loading变量表示loading状态
// 一个load函数
// 该函数和变量通过inject从父组件传到子组件
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clearListen: null,
      clearJobBoard: null
    }
  },
  // 监听滚动条触底，触发load函数
  mounted() {
    this.clearListen = listenerScrollToBottom(this.load);
    listenerFixedJobBoard(this.fixed);
  },
  // 组件销毁前必须解除事件绑定
  deactivated() {
    this.clearListen()
    //this.clearJobBoard()
  },
  methods: {
    load() {
      this.$emit('load')
    },
    fixed(value) {
      this.$emit('fixed', value);
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  background-color: #ecedf3;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  color: #333333;
}

</style>
